export const hasAlternateAddress = (value: any): boolean => {
  return (
    !value.alternativeAddress ||
    (!value.alternativeAddress.addressLine &&
      !value.alternativeAddress.city &&
      !value.alternativeAddress.state &&
      !value.alternativeAddress.zipCode)
  );
};
